import React from "react";
import PostBox from "../../components/PostBox";
import Navbar from "../global/Navbar";
// import Footer from "../global/Footer";
import { Box } from "@mui/material";
import { motion } from "motion/react";

const Page = () => {
  const containerVariants = {
    hidden: { opactiy: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        staggerChildren: 0.2,
      },
    },
  };
  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };


  return (
    <Box
      sx={{
        width: { xs: "90vw", md: "50vw" }, // 90% viewport width on mobile, 50% on desktop
        margin: "0 auto", // Center horizontally
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        pt: 15, // Less padding on mobile, more on desktop
        borderRadius: 2,
      }}
    >
      <Navbar /> 
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={containerVariants}
      >
        <Box
          id="posts"
          sx={{
            justifyContent: "center",
            padding: { xs: 2, md: 4 },
          }}
        >
          <motion.h2 variants={itemVariants}>
            <PostBox
              date={"9/15/2025"}
              title={"What I learned deploying my app to AWS"}
              tags={["cloud", "ci/cd"]}
              link={"/sept15"}
            />
          </motion.h2>
        </Box>
      </motion.div>
      {/* <Footer /> */}
    </Box>
  );
};

export default Page;
